<template>
  <div class="dashboard-markero">
    <Feature
      :feature-slug="featureNames.COMPANY"
      v-if="!mobile"
    >
      <DashboardStandardHeader />
    </Feature>

    <div
      :class="{
        'dashboard-markero__layout': true,
        'dashboard-markero__layout--desktop': !mobile,
      }"
    >
      <div class="dashboard-markero__layout-left">
        <DashboardMarkeroSuggestion
          v-if="mobile"
          :class="{
            'dashboard-markero__layout-left-suggestions--new-user': !twoWeeksAfterRegistration,
          }"
        />
        <Feature
          v-slot="{ feature }"
          :feature-slug="featureNames.PRODUCTFRUITS"
        >
          <ProductFruitsChecklist
            v-if="feature.config.checklistCodeFirstSteps"
            :full-height="!mobile"
          />
        </Feature>
      </div>
      <div
        class="dashboard-markero__layout-right"
        v-if="!mobile"
      >
        <DashboardMarkeroTopics />
        <DashboardMarkeroContent />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useQuery } from '@vue/apollo-composable'
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

import featureNames from '@/lib/featureNames'
import ProductFruitsChecklist from '@/modules/productFruitsChecklist/index.vue'
import { Feature } from '@/plugins/feature-config'
import IDENTITY from '@/queries/Identity.gql'

import DashboardStandardHeader from '../DashboardStandardHeader.vue'
import DashboardMarkeroContent from './DashboardMarkeroContent.vue'
import DashboardMarkeroSuggestion from './DashboardMarkeroSuggestion.vue'
import DashboardMarkeroTopics from './DashboardMarkeroTopics.vue'

const { mobile } = useDisplay()

const { result } = useQuery(IDENTITY)

const twoWeeksAfterRegistration = computed(() => {
  if (!result.value) return false
  if (!result.value?.identity?.user?.createdAt) return false

  const registrationDate = new Date(result.value.identity.user.createdAt)
  const twoWeeksAfterRegistration = new Date(registrationDate.getTime() + 14 * 24 * 60 * 60 * 1000)
  const now = new Date()

  return now >= twoWeeksAfterRegistration
})
</script>
<style scoped>
.dashboard-markero {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.dashboard-markero__layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.dashboard-markero__layout--desktop {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.dashboard-markero__layout-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}
.dashboard-markero__layout-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.dashboard-markero__layout-left-suggestions--new-user {
  order: 2;
}
</style>
